export default Object.freeze({
  enUS: 'en-US',
  esES: 'es-ES',
});
